'use client' // Error components must be Client Components

import Image from 'next/image'
import Link from 'next/link'
import { useEffect } from 'react'

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error)
    }, [error])

    return (
        <div className="flex flex-col gap-12 2xl:px-[500px] px-[300px] py-[100px] max-lg:px-8 max-md:flex-col items-center justify-center ">
            <Image
                src="/assets/icons/glofi_hand_orange.svg"
                height={222}
                width={200}
                alt=""
                className="max-md:absolute max-md:-left-6 max-md:rotate-90 max-md:w-[80px] "
            />
            <div className="flex flex-col items-center">
                <p className="text-4xl font-semibold text-black ">Ops, algo deu errado!</p>
            </div>
            <button
                type="button"
                onClick={() => reset()}
                className="w-full py-2 text-lg font-bold text-white uppercase rounded-full bg-healthy-green-light hover:bg-primary-green"
            >
                Tentar novamente
            </button>
            <Link href="/" className="flex gap-2 text-lg uppercase text-orange hover:underline">
                <Image
                    src="/assets/icons/orange-arrow-left.svg"
                    height={28}
                    width={20}
                    alt=""
                    className="max-md:absolute max-md:-left-6 max-md:rotate-90 max-md:w-[80px]"
                />
                Voltar para a página inicial
            </Link>
        </div>
    )
}
